import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { UnsavedSceneService } from 'src/app/services/unsaved-scene.service';
import { AuthorService } from 'src/app/services/author.service';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-edit-question-in-question-set-modal',
  templateUrl: './edit-question-in-question-set-modal.page.html',
  styleUrls: ['./edit-question-in-question-set-modal.page.scss'],
})
export class EditQuestionInQuestionSetModalPage implements OnInit {

  public assetInScene: AssetInScene;
  public previewing: boolean = false;
  public ionSelectFontOptions = {
    cssClass: 'select-font'
  };

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public unsavedSceneService: UnsavedSceneService,
    public authorService: AuthorService,
    public validationService: ValidationService,
  ) { }

  ngOnInit() {
  }  

  setIsSaved(isSaved) {
    this.unsavedSceneService.setHasSceneBeenSaved(isSaved);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  setTransparency(elementId: string, opacity: number) {
    document.getElementById(elementId).setAttribute('style', 'opacity: ' + opacity);
  }

  previewQuestion(){
    this.previewing = !this.previewing;
    this.setTransparency('edit-question-in-question-set-modal', this.previewing == true ? 0.3 : 1);
  }

  getQuestionAsset(): QuestionAsset{
    var questionAsset = this.assetInScene.baseAsset as QuestionAsset;
    return questionAsset;
  }

  getQuestionTextSize(asset: QuestionAsset): number {
    return 55 - asset.textSize;
  }

  getQuestionAssetResponses(questionAsset: QuestionAsset){
    return questionAsset.responses
      .filter(r => r.toBeRemoved !== true)
      .sort((a,b) => a.questionResponseIndex > b.questionResponseIndex ? 1 : -1);
  }

  setQuestionTextSize(ev, asset: QuestionAsset) {
    var value = parseFloat(ev.target.value);
    value = 55 - value;
    asset.textSize = value;
  }

  updateQuestionResponseIsCorrect(baseAsset: QuestionAsset, correctResponseIndex) {
    baseAsset.responses.filter(r => r.toBeRemoved !== true).forEach(element => {
      element.isCorrect = false;
    });
    baseAsset.responses[correctResponseIndex].isCorrect = true;
  }
  
  addResponse(baseAsset: QuestionAsset) {
    this.authorService.addResponseToQuestion(baseAsset);
  }

  deleteResponse(baseAsset: QuestionAsset, responseToDelete: QuestionResponse) {
    responseToDelete.toBeRemoved = true;

    if (baseAsset.responses.filter(r => r.isCorrect === true && r.toBeRemoved !== true).length <= 0) {
      this.getQuestionAssetResponses(baseAsset)[0].isCorrect = true;
    }
    setTimeout(() => { this.authorService.reinitQuestionResponsesPositions(this.assetInScene.sceneAssetRelation.sceneAssetRelationId) }, 200);
  }

  validateScoreValue(event, asset: AssetInScene){
    var questionAsset: QuestionAsset = asset.baseAsset as QuestionAsset;
    var value = +event.target.value;
    value = this.validationService.validateMinValue(value, 0.5);
    value = this.validationService.validateMaxValue(value, 5);
    if(value != Math.floor(value)){
      value = Math.floor(value) + 0.5;
    }
    questionAsset.score = value;
  }

  changeQuestionResponsesFontFamily(event, questionAsset: QuestionAsset){
    questionAsset.responses.forEach(response => {
      response.fontFamily = event.target.value;
    });
  }

  editQuestionResponses(assetInScene: AssetInScene){
    this.authorService.editResponsesProperties(assetInScene, () => {this.previewQuestion()});
  }

}
